export function isMatDatePickerClick(mouseEvent: MouseEvent): boolean {
  let targetElement: HTMLElement = mouseEvent.target as HTMLElement
  do {
    if (targetElement.tagName.toLowerCase() === "mat-datepicker-content") {
      return true
    }

    targetElement = (targetElement as HTMLElement).parentNode as any
  } while (targetElement && targetElement.tagName && targetElement.parentNode)

  return false
}
